import type { IntlShape } from 'react-intl'
import type { TripDrawerPresentation } from 'tripPlanner/components/GenericDrawer/TripDrawerPresentationContext'

export function formatTripDrawerMapLabel(
  intl: IntlShape,
  drawerPresentation: TripDrawerPresentation,
) {
  if (drawerPresentation === 'modal') {
    return intl.formatMessage({
      id: 'A4d853WBO8SnGjK-HuZ9',
      defaultMessage: 'Map',
      description:
        'Short mobile drawer header chip label that opens the map for the current trip planner item.',
    })
  }

  return intl.formatMessage({
    id: 'WlIUpdHwd6vZ2b8PMCg0',
    defaultMessage: 'Show map',
    description:
      'Button label shown in the drawer header to open the map for the current trip planner location or offer.',
  })
}
